import axios from "axios";
import axiosInstance from "../../axios";

const baseURL = axiosInstance.defaults.baseURL;

const locationClient = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Platform":
      axiosInstance.defaults.headers?.common?.["X-Platform"] ||
      process.env.REACT_APP_PLATFORM,
    "X-API-Key":
      axiosInstance.defaults.headers?.common?.["X-API-Key"] ||
      process.env.REACT_APP_API_KEY,
  },
});

locationClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("mp_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const sortByName = (items = []) =>
  [...items].sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""), "id", {
      sensitivity: "base",
    })
  );

const normalizeList = (payload) =>
  Array.isArray(payload?.data) ? payload.data : [];

const fetchList = async (path) => {
  if (!baseURL) {
    throw new Error("REACT_APP_API_URL belum diatur.");
  }

  const { data } = await locationClient.get(path);
  return sortByName(normalizeList(data));
};

export const getProvinces = () => fetchList("/location/provinces");
export const getRegencies = (code) => fetchList(`/location/regencies/${code}`);
export const getDistricts = (code) => fetchList(`/location/districts/${code}`);
export const getVillages = (code) => fetchList(`/location/villages/${code}`);